module.exports = __webpack_public_path__ + "img/performance-3.6e40e19a.png";